module.exports = __webpack_public_path__ + "static/sport/bgi-pc.6faf595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/bgi-pc.png
// module id = ZOtn
// module chunks = 0